import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {DLPageTypeEnum} from '../../../../../../enums/DataLayerEnums';
import {SearchWidgetV3StateService} from '../../../../../../components/search-widget-v3/services/search-widget-v3-state.service';

@Component({
  selector: 'app-search-content-search',
  templateUrl: './search-content-search.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class:
      'flex flex-col gap-4 rounded-lg border border-grey-9 bg-grey-10 px-4 py-5 lg:p-0 lg:border-0 lg:bg-transparent',
  },
})
export class SearchContentSearchComponent {
  public title = input<string>(null);
  public pageType = input<DLPageTypeEnum>(null);
  public content = computed<string>(() => {
    if (this.title() && this.pageType()) {
      if (this.pageType() === DLPageTypeEnum.CARE_SERVICE_TYPE_PAGE) {
        return `Vill du hitta en mottagning som erbjuder <b>${this.title()}</b>?`;
      } else {
        return `Vill du hitta en mottagning som kan hjälpa dig med <b>${this.title()}</b>?`;
      }
    }
  });
  private searchWidgetState = inject(SearchWidgetV3StateService);

  protected expandSearchWidgetWithPlaceFocused($event): void {
    this.searchWidgetState.updateShouldFocusPlacesField(true);
    this.searchWidgetState.updateIsSearchWidgetExpanded(true);
  }
}
